<template>
  <div class="lang-switcher" ref="rootEl">
    <button class="lang-btn" @click="open = !open" aria-label="Choisir la langue / Choose language">
      <span class="lang-flag">{{ current?.flag || '🌐' }}</span>
    </button>
    <div v-if="open" class="lang-dropdown">
      <button
        v-for="lang in LANGUAGES"
        :key="lang.code"
        class="lang-option"
        :class="{ active: lang.code === locale }"
        @click="select(lang.code)"
      >
        <span class="lang-option-flag">{{ lang.flag }}</span>
        <span>{{ lang.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { LANGUAGES, useLocale } from '@/i18n'

const { locale, setLocale } = useLocale()
const open = ref(false)
const rootEl = ref(null)
const current = computed(() => LANGUAGES.find(l => l.code === locale.value))

function select(code) {
  setLocale(code)
  open.value = false
}

function onClickOutside(e) {
  if (open.value && rootEl.value && !rootEl.value.contains(e.target)) open.value = false
}

onMounted(() => document.addEventListener('click', onClickOutside))
onUnmounted(() => document.removeEventListener('click', onClickOutside))
</script>

<style scoped>
.lang-switcher {
  position: fixed;
  bottom: 14px;
  right: 14px;
  z-index: 9999999;
}

.lang-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid rgba(201, 168, 76, 0.4);
  background: rgba(20, 19, 14, 0.85);
  backdrop-filter: blur(6px);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  transition: border-color 0.2s ease, transform 0.2s ease;
  padding: 0;
}

.lang-btn:hover {
  border-color: #c9a84c;
  transform: scale(1.06);
}

.lang-dropdown {
  position: absolute;
  bottom: 50px;
  right: 0;
  background: #14130e;
  border: 1px solid rgba(201, 168, 76, 0.3);
  border-radius: 8px;
  padding: 6px;
  min-width: 168px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  background: none;
  border: none;
  color: #ddd8cf;
  font-size: 0.85rem;
  font-family: 'Segoe UI', sans-serif;
  text-align: left;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.2s ease, color 0.2s ease;
}

.lang-option:hover {
  background: rgba(201, 168, 76, 0.12);
}

.lang-option.active {
  color: #c9a84c;
  font-weight: 600;
}

.lang-option-flag {
  font-size: 1.1rem;
}

@media (max-width: 680px) {
  .lang-switcher {
    /* Décalé au-dessus de la barre de navigation mobile (bottom-nav de la page Menu) */
    bottom: 66px;
    right: 8px;
  }

  .lang-btn {
    width: 36px;
    height: 36px;
    font-size: 17px;
  }

  .lang-dropdown {
    bottom: 44px;
  }
}
</style>
